export default __webpack_public_path__ + "static/section-5-img-2@2x-e67ad2703598689c759be68bce67354b.png";